import { ProtocolsType } from 'types/Protocols.types'

export const types = Object.freeze({
  FETCH_ALL: '@protocols/fetchAll',
  FETCH_ONE: '@protocols/fetchOne',
  CREATE_PROTOCOLS: '@protocols/createProtocols',
  UPDATE_PROTOCOLS: '@protocols/updateProtocols',
  EDIT_PROTOCOLS: '@protocols/editProtocols',
  CLEAN_PROTOCOLS: '@protocols/cleanProtocols',
  FILTER_PROTOCOLS: '@protocols/filterProtocols',
  GET_PROTOCOLS_OPTIONS: '@protocols/getProtocolsOptions',
  SET_PROTOCOLS_OPTIONS: '@protocols/setProtocolsOptions',
  SET_LOADING: '@protocols/setLoading',
  SET_PROTOCOLS: '@protocols/setProtocols',
  SET_CREATED_PROTOCOLS: '@protocols/setCreatedProtocols',
  SET_UPDATED_PROTOCOLS: '@protocols/setUpdatedProtocols',
  SET_SELECTED_PROTOCOLS: '@protocols/setSelectedProtocols',
  DELETE_PROTOCOLS: '@protocols/deleteProtocols'
})

export function setLoading({ loading = false } = {}) {
  return { type: types.SET_LOADING, payload: { loading } }
}

export function fetchAll(filters = {}) {
  return { type: types.FETCH_ALL, payload: { filters } }
}

export function setProtocols({ protocols = [] } = {}) {
  return {
    type: types.SET_PROTOCOLS,
    payload: { protocols, loading: false }
  }
}

export function setCreatedProtocols({ protocolsCreated = {} } = {}) {
  return {
    type: types.SET_CREATED_PROTOCOLS,
    payload: { protocolsCreated, loading: false }
  }
}

export function setUpdatedProtocols({ protocolsUpdated = {} } = {}) {
  return {
    type: types.SET_UPDATED_PROTOCOLS,
    payload: { protocolsUpdated, loading: false }
  }
}

export function setSelectedProtocols({ selectedCertifications = null } = {}) {
  return {
    type: types.SET_PROTOCOLS,
    payload: { selectedCertifications }
  }
}

export function createProtocols(protocols: ProtocolsType) {
  return {
    type: types.CREATE_PROTOCOLS,
    payload: protocols
  }
}

export function updateProtocols(protocols: ProtocolsType) {
  return {
    type: types.UPDATE_PROTOCOLS,
    payload: protocols
  }
}

export function cleanProtocols() {
  return {
    type: types.CLEAN_PROTOCOLS,
    payload: {
      editProtocols: {},
      protocolsUpdated: {},
      protocolsCreated: {}
    }
  }
}

export function editProtocols({ editProtocols = {} }) {
  return {
    type: types.EDIT_PROTOCOLS,
    payload: { editProtocols }
  }
}

export function fetchOne(id: string) {
  return { type: types.FETCH_ONE, payload: { id } }
}

export function filterProtocols({ certificationsId, params }) {
  return {
    type: types.FILTER_PROTOCOLS,
    payload: { certificationsId, params }
  }
}

export function getProtocolsOptions() {
  return { type: types.GET_PROTOCOLS_OPTIONS }
}

export function setProtocolsOptions({ options = [] } = {}) {
  return {
    type: types.SET_PROTOCOLS_OPTIONS,
    payload: { options }
  }
}

export function deleteProtocols(id: string) {
  return { type: types.DELETE_PROTOCOLS, payload: { id } }
}
